import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { Database } from "@/integrations/supabase/types";
import { useState } from "react";

type RuleSet = Database["public"]["Tables"]["template_field_rule_sets"]["Row"] & {
  rules: Database["public"]["Tables"]["template_field_rules"]["Row"][];
};

interface EditRuleSetDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ruleSet: RuleSet | null;
  onSave: (name: string, description?: string) => Promise<void>;
}

export const EditRuleSetDialog = ({ open, onOpenChange, ruleSet, onSave }: EditRuleSetDialogProps) => {
  const [name, setName] = useState(ruleSet?.name ?? "");
  const [description, setDescription] = useState(ruleSet?.description ?? "");

  if (!ruleSet) return null;

  const handleSave = async () => {
    await onSave(name, description);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Rule Set</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="edit-name">Name</Label>
            <Input
              id="edit-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter rule set name"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="edit-description">Description</Label>
            <Textarea
              id="edit-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter rule set description"
            />
          </div>
        </div>
        <div className="flex justify-end space-x-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
